<div *ngIf="hasValue" class="severity-bar">
  <div class="progress">
    <div class="progress-bar" [style.width.%]="percentage" [style.background-color]="color" aria-valuemin="0" aria-valuemax="100">
    </div>
  </div>
  <span>{{displayValue}}</span>
</div>
<div *ngIf="!hasValue">No Data</div>
